import React from 'react';
import { useAjax } from '@developers/use-ajax';
import * as addressAjax from '../ajax/addresses';
import type { Address } from '../types/Address';
import type { AjaxMeta } from '@developers/types/common/AjaxMeta';

interface Functions {
  getServicersByZip: (zip: string | number, distance: number) => void;
  getServicersByState: (id: number) => void;
}

/**
 * Custom hook that combines the data, amd meta data for two types of ajax calls to retrieve service providers.
 * 
 * The two methods for getting servicers are by postal code, or by state.
 */
export function useServiceProviders(): [Address[], Functions, AjaxMeta] {
  const [option, setOption] = React.useState('zip');

  const [servicers_by_zip, getServicersByZip, getServicersByZipMeta] = useAjax(addressAjax.getServicersByZip, [] as Address[]);
  const [servicers_by_state, getServicersByState, getServicersByStateMeta] = useAjax(addressAjax.getServicersByState, [] as Address[]);

  function getServicersByZipWrapper(zip: string | number, distance: number) {
    setOption('zip');
    getServicersByZip(zip, distance);
  }

  function getServicersByStateWrapper(id: number) {
    setOption('state');
    getServicersByState(id);
  }

  return [
    (option === 'zip' ? servicers_by_zip : servicers_by_state),
    {
      getServicersByZip: React.useCallback(getServicersByZipWrapper, []),
      getServicersByState: React.useCallback(getServicersByStateWrapper, []),
    },
    (option === 'zip' ? getServicersByZipMeta : getServicersByStateMeta),
  ];
}